/* raw layout hash: _executive-management-dashboard-layout:918503bae3faa3505b491284410bb54c06a648331c0bc8af4a9509619c27d028 */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _executive-management-dashboard-layout.html — top navbar + mobile bottom bar. Menu entries are role-based (see AppShell / menuData.js).

export default function ExecutiveManagementDashboardLayout() {
  return <AppShell />;
}
